/**
 * 神策埋点属性解析；空值在上报前会被过滤（见 sensorProvider）。
 */

/** 无效数字统一为 undefined，表示不传该属性 */
export function sensorParseNumber(value: string | number | null | undefined): number | undefined {
  if (value == null) return undefined;
  if (typeof value === 'string') {
    const t = value.trim();
    if (t === '') return undefined;
    const n = Number(t);
    return Number.isFinite(n) ? n : undefined;
  }
  return Number.isFinite(value) ? value : undefined;
}

/** 神策侧字符串；null/undefined → ''（与过滤逻辑一致） */
export function sensorParseString(value: string | number | boolean | null | undefined): string {
  if (value == null) return '';
  return typeof value === 'string' ? value.trim() : String(value);
}
